import React from 'react';
import { C, PLUS_R, nx, ny } from '../flowCanvas.constants';

export default function InfoButtonNode({ step, selected, onClick, centreY, overrideX, overrideY }) {
  const x = overrideX ?? nx(step);
  const y = overrideY ?? ny(step, centreY);
  const r = PLUS_R;

  return (
    <g className="fc-node fc-node--info-button" onClick={onClick} style={{ cursor: 'pointer' }}>
      <circle
        cx={x}
        cy={y}
        r={r}
        fill={selected ? C.sel : C.neonBlue}
        stroke="none"
      />
      <text
        x={x}
        y={y + 1}
        textAnchor="middle"
        dominantBaseline="middle"
        fontSize="12"
        fontWeight="700"
        fill="#fff"
        style={{ pointerEvents: 'none', userSelect: 'none' }}
      >
        i
      </text>
    </g>
  );
}
